import { useEffect, useState } from "react";
import API from "../services/api";

export default function Leads() {
    const [leads, setLeads] = useState([]);

    useEffect(() => {
        fetchLeads();
    }, []);

    const fetchLeads = async () => {
        const res = await API.get("/leads");
        setLeads(res.data || []);
    };

    const updateStatus = async (id, status) => {
        await API.put(`/leads/${id}/status`, { status });
        fetchLeads();
    };

    return (
        <div className="p-8 text-white">
            <h1 className="text-2xl mb-6">Leads</h1>

            <div className="bg-white/10 backdrop-blur-xl rounded-xl overflow-hidden">
                <table className="w-full text-left">
                    <thead className="bg-white/10">
                        <tr>
                            <th className="p-3">Name</th>
                            <th>Email</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        {leads.map((l) => (
                            <tr key={l.id} className="border-t border-white/10">
                                <td className="p-3">{l.fullName}</td>
                                <td>{l.email}</td>
                                <td>
                                    <span className="px-2 py-1 rounded bg-purple-600 text-xs">
                                        {l.status}
                                    </span>
                                </td>
                                <td>
                                    <select
                                        onChange={(e) =>
                                            updateStatus(l.id, e.target.value)
                                        }
                                        className="bg-black p-1 rounded"
                                    >
                                        <option>New</option>
                                        <option>Contacted</option>
                                        <option>Closed</option>
                                    </select>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}